module.exports = __webpack_public_path__ + "media/images/konintodoke/other_services/services03-5464fd8842c9fac5a9e18d11d4f89ebc.jpg";